import { useEffect, useState } from "react";
import { useFavorite, type FavoriteType } from "@/hooks/useFavorites";
import { copyCurrentLink } from "@/utils/share";

interface DetailActionsProps {
  type: FavoriteType;
  id: string;
}

export default function DetailActions({ type, id }: DetailActionsProps) {
  const { isFavorite, toggleFavorite } = useFavorite(type, id);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 2200);
    return () => window.clearTimeout(timer);
  }, [copied]);

  const handleShare = async () => {
    const ok = await copyCurrentLink();
    setCopied(ok);
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={() => toggleFavorite()}
          aria-pressed={isFavorite}
          className={`inline-flex items-center gap-2 whitespace-nowrap rounded-md px-4 py-2.5 text-sm font-medium transition-colors ${
            isFavorite
              ? "bg-accent-500 text-background-950 hover:bg-accent-400"
              : "border border-background-600 bg-background-900 text-foreground-100 hover:border-accent-500/70 hover:text-accent-400"
          }`}
        >
          <i className={`${isFavorite ? "ri-bookmark-fill" : "ri-bookmark-line"} text-base`} />
          {isFavorite ? "已收藏" : "收藏"}
        </button>
        <button
          type="button"
          onClick={handleShare}
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-600 bg-background-900 px-4 py-2.5 text-sm font-medium text-foreground-100 transition-colors hover:border-secondary-400 hover:text-secondary-200"
        >
          <i className="ri-share-forward-line text-base" />
          分享链接
        </button>
        <span className="text-xs text-foreground-500">收藏保存在本机浏览器，仅作演示</span>
      </div>
      {copied && (
        <p className="animate-fade-slow flex items-center gap-1.5 text-xs text-accent-400">
          <i className="ri-checkbox-circle-line text-sm" />
          链接已复制到剪贴板，可以分享给朋友了
        </p>
      )}
    </div>
  );
}